// "Production" enabled environment

export const environment = {
  production: true,
  hmr: false,
  appConfig: 'appconfig.demo.json',
};
